import _get from '../../../../@babel/runtime/helpers/esm/get.js';
import _classCallCheck from '../../../../@babel/runtime/helpers/esm/classCallCheck.js';
import _createClass from '../../../../@babel/runtime/helpers/esm/createClass.js';
import _possibleConstructorReturn from '../../../../@babel/runtime/helpers/esm/possibleConstructorReturn.js';
import _getPrototypeOf from '../../../../@babel/runtime/helpers/esm/getPrototypeOf.js';
import _inherits from '../../../../@babel/runtime/helpers/esm/inherits.js';
import _wrapNativeSuper from '../../../../@babel/runtime/helpers/esm/wrapNativeSuper.js';
import regenerator from '../../../../@babel/runtime/regenerator/index.js';

function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
var APEX_SLOT_TAGS;
(function (APEX_SLOT_TAGS) {
  APEX_SLOT_TAGS["SLOT"] = "s-slot";
  APEX_SLOT_TAGS["SLOT_ROOT"] = "s-root";
  APEX_SLOT_TAGS["FALLBACK_WRAPPER"] = "s-fallback-wrapper";
  APEX_SLOT_TAGS["ASSIGNED_WRAPPER"] = "s-assigned-wrapper";
})(APEX_SLOT_TAGS || (APEX_SLOT_TAGS = {}));
var APEX_SLOT_ATTRS;
(function (APEX_SLOT_ATTRS) {
  APEX_SLOT_ATTRS["SLOTTED"] = "data-apex-slotted";
})(APEX_SLOT_ATTRS || (APEX_SLOT_ATTRS = {}));

/* eslint-disable @typescript-eslint/no-explicit-any */
function ApexSlotableMixin(superclass, options) {
  var DEFAULT_SLOT_INTROSPECTION_OPTIONS = {
    ignoreComments: false,
    ignoreWhitespace: false
  };
  var slotTag = (options === null || options === void 0 ? void 0 : options.slotTag) || APEX_SLOT_TAGS.SLOT;
  var slotRootTag = (options === null || options === void 0 ? void 0 : options.slotRootTag) || APEX_SLOT_TAGS.SLOT_ROOT;
  if (options) {
    slotTag = options.slotTag || slotTag;
    slotRootTag = options.slotRootTag || slotRootTag;
  }
  var ApexSlot = /*#__PURE__*/function (_HTMLElement) {
    _inherits(ApexSlot, _HTMLElement);
    function ApexSlot() {
      var _this;
      _classCallCheck(this, ApexSlot);
      _this = _callSuper(this, ApexSlot);
      _this.name = '';
      _this._slotRendered = false;
      _this._slotRenderAttempts = 0;
      _this._maxSlotRenderAttempts = 10;
      _this.name = _this.getAttribute('name') || '';
      return _this;
    }
    _createClass(ApexSlot, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this2 = this;
        this._slotUpdateCompleted = new Promise(function (resolve, reject) {
          var id = setInterval(function () {
            _this2._slotRenderAttempts++;
            try {
              if (_this2._slotRendered) {
                resolve(undefined);
              } else if (_this2._slotRenderAttempts >= _this2._maxSlotRenderAttempts) {
                throw new Error('Slot Rendering Timeout');
              }
            } catch (e) {
              reject(e);
            } finally {
              clearInterval(id);
            }
          }, 50);
        });
        this.sRoot = this.closest(slotRootTag);
        /**
         * We want the developer to remove the mixin as opposed to failing gracefully when it is
         * used on a component that does not contain any slots because
         * this component adds a lot of unnecessary code to components that don't need it
         * as well as trying to set up and remove observers.
         */
        if (!this.sRoot) {
          throw new Error('No slot in component! Remove mixin if not using slots!');
        }
        this.removeAttribute(APEX_SLOT_ATTRS.SLOTTED);
        // Observe the "Light DOM" of the component, to detect when new nodes are added and assign them to the <apex-slot> if necessary
        this.lightDomObserver = new MutationObserver(function () {
          _this2._slotRendered = false;
          _this2.updateAssignedContent();
        });
        this.lightDomObserver.observe(this.sRoot.parentElement, {
          childList: true
        });
        // Create assigned content and fallback content wrappers
        this.fallbackWrapper = this.fallbackWrapper || this.createFallbackWrapper();
        this.assignedWrapper = this.assignedWrapper || this.createAssignedWrapper();
        // Observe the assignedContentWrapper (so default content can be shown if all slotables are deleted)
        var assignedContentObserver = new MutationObserver(function () {
          _this2._slotRendered = false;
          _this2.updateEmptySlot(); // This is an observer on the actual <apex-slot>
          _this2.dispatchEvent(new CustomEvent('slotchange', {
            bubbles: true
          }));
        });
        assignedContentObserver.observe(this.assignedWrapper, {
          childList: true
        });
        this.updateAssignedContent();
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        var _a;
        // we don't want to move any nested slot content
        if ((_a = this.assignedWrapper.parentElement) === null || _a === void 0 ? void 0 : _a.hasAttribute(APEX_SLOT_ATTRS.SLOTTED)) {
          return;
        }
        this.lightDomObserver.disconnect(); // don't let observers pile up
        var element = this.sRoot && this.sRoot.parentElement;
        var fragment = document.createDocumentFragment();
        Array.from(this.assignedWrapper.childNodes).forEach(function (child) {
          fragment.appendChild(child);
        });
        if (element) {
          element.appendChild(fragment);
        }
        this.sRoot = null;
      }
    }, {
      key: "createFallbackWrapper",
      value: function createFallbackWrapper() {
        if (!customElements.get(APEX_SLOT_TAGS.FALLBACK_WRAPPER)) {
          var SFallbackWrapper = /*#__PURE__*/function (_HTMLElement2) {
            _inherits(SFallbackWrapper, _HTMLElement2);
            function SFallbackWrapper() {
              _classCallCheck(this, SFallbackWrapper);
              return _callSuper(this, SFallbackWrapper, arguments);
            }
            return _createClass(SFallbackWrapper);
          }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
          customElements.define(APEX_SLOT_TAGS.FALLBACK_WRAPPER, SFallbackWrapper);
        }
        var fallbackNodes = Array.from(this.childNodes).filter(function (n) {
          return n.tagName === undefined || n.tagName.toLowerCase() !== APEX_SLOT_TAGS.ASSIGNED_WRAPPER;
        });
        // This is only called once, get the contents of this <apex-slot> and wrap them in a span
        if (fallbackNodes.length === 0) {
          // there's no default content, don't create the wrapper
          return false;
        } else {
          var fallbackWrapper = document.createElement(APEX_SLOT_TAGS.FALLBACK_WRAPPER);
          fallbackNodes.forEach(function (node) {
            fallbackWrapper.appendChild(node);
          });
          this.appendChild(fallbackWrapper); // Add the fallback span to the component;
          return fallbackWrapper;
        }
      }
    }, {
      key: "createAssignedWrapper",
      value: function createAssignedWrapper() {
        if (!customElements.get(APEX_SLOT_TAGS.ASSIGNED_WRAPPER)) {
          var SAssignedWrapper = /*#__PURE__*/function (_HTMLElement3) {
            _inherits(SAssignedWrapper, _HTMLElement3);
            function SAssignedWrapper() {
              _classCallCheck(this, SAssignedWrapper);
              return _callSuper(this, SAssignedWrapper, arguments);
            }
            return _createClass(SAssignedWrapper);
          }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
          customElements.define(APEX_SLOT_TAGS.ASSIGNED_WRAPPER, SAssignedWrapper);
        }
        var assignedWrapper = document.createElement(APEX_SLOT_TAGS.ASSIGNED_WRAPPER);
        this.appendChild(assignedWrapper); // Add the assigned span to the component;
        return assignedWrapper;
      }
    }, {
      key: "updateAssignedContent",
      value: function updateAssignedContent() {
        var _this3 = this;
        var lightDOM = this.sRoot.parentElement;
        var unplacedNodes = Array.from(lightDOM.childNodes).filter(function (node) {
          return node.parentNode === _this3.sRoot.parentElement && node !== _this3.sRoot; // return all nodes outside the <apex-root>, they haven't been moved yet
        });
        var content = [];
        if (this.name) {
          // Handle named slots
          content = unplacedNodes.filter(function (node) {
            return node.nodeType === Node.ELEMENT_NODE && node.getAttribute('slot') === _this3.name;
          });
        } else {
          // Handle default slot content
          content = unplacedNodes.filter(function (n) {
            if (n.nodeType !== Node.ELEMENT_NODE) {
              return n;
            } else if (typeof n.getAttribute === 'function' && !n.getAttribute('slot')) {
              return n;
            }
            return undefined;
          });
        }
        if (content.length > 0) {
          // Some slotable content was found, remove default content
          var fragment = document.createDocumentFragment();
          content.forEach(function (node) {
            // any child nodes that are slots, we need to make sure they don't potentially
            // get moved out of place by disconnectedCallback on a parent slot unintentionally
            if (node.nodeType === Node.ELEMENT_NODE) {
              var allSlots = Array.from(node.querySelectorAll(slotTag));
              if (node.nodeName === slotTag) {
                node.setAttribute(APEX_SLOT_ATTRS.SLOTTED, '');
              }
              if (allSlots.length) {
                allSlots.forEach(function (descendentNod) {
                  descendentNod.setAttribute(APEX_SLOT_ATTRS.SLOTTED, '');
                });
              }
            }
            fragment.appendChild(node);
          });
          this.assignedWrapper.appendChild(fragment);
          if (this.fallbackWrapper) {
            this.fallbackWrapper.setAttribute('hidden', 'true');
            this.assignedWrapper.removeAttribute('hidden'); // Do a visibility toggle so the mutationObserver will not be triggered and create a loop
          }
        }
        this._slotRendered = true;
      }
    }, {
      key: "updateEmptySlot",
      value: function updateEmptySlot() {
        if (this.fallbackWrapper && this.assignedWrapper.childNodes.length === 0) {
          this.fallbackWrapper.removeAttribute('hidden');
          this.assignedWrapper.setAttribute('hidden', 'true'); // Do a visibility toggle so the mutationObserver will not be triggered and create a loop
        }
        this._slotRendered = true;
      }
    }]);
    return ApexSlot;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
  return /*#__PURE__*/function (_superclass) {
    _inherits(ClassInTransition, _superclass);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    function ClassInTransition() {
      var _this4;
      _classCallCheck(this, ClassInTransition);
      _this4 = _callSuper(this, ClassInTransition);
      if (!customElements.get(slotRootTag)) {
        var ApexSlotRoot = /*#__PURE__*/function (_HTMLElement4) {
          _inherits(ApexSlotRoot, _HTMLElement4);
          function ApexSlotRoot() {
            _classCallCheck(this, ApexSlotRoot);
            return _callSuper(this, ApexSlotRoot, arguments);
          }
          return _createClass(ApexSlotRoot);
        }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
        customElements.define(slotRootTag, ApexSlotRoot);
      }
      if (!customElements.get(slotTag)) {
        customElements.define(slotTag, ApexSlot);
      }
      return _this4;
    }
    _createClass(ClassInTransition, [{
      key: "createRenderRoot",
      value: function createRenderRoot() {
        // Wrap the entire rendered output in an <apex-root> element
        var existingSRoot = Array.from(this.childNodes).find(function (n) {
          var _a;
          return ((_a = n.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === slotRootTag;
        });
        if (existingSRoot !== undefined) {
          return existingSRoot;
        } else {
          return document.createElement(slotRootTag);
        }
      }
    }, {
      key: "firstUpdated",
      value: function firstUpdated() {
        // Ensure the contents are wrapped in the <apex-root> element
        if (!this.renderRoot.parentElement) {
          this.appendChild(this.renderRoot);
        }
        // @ts-ignore
        _get(_getPrototypeOf(ClassInTransition.prototype), "firstUpdated", this).call(this);
      }
    }, {
      key: "getUpdateComplete",
      value: function getUpdateComplete() {
        var _this5 = this;
        var _super = Object.create(null, {
          getUpdateComplete: {
            get: function get() {
              return _get(_getPrototypeOf(ClassInTransition.prototype), "getUpdateComplete", _this5);
            }
          }
        });
        return __awaiter(this, void 0, void 0, /*#__PURE__*/regenerator.mark(function _callee() {
          var slotPromises;
          return regenerator.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _super.getUpdateComplete.call(this);
              case 2:
                slotPromises = Array.from(this.querySelectorAll(slotTag)).map(
                // eslint-disable-next-line no-underscore-dangle
                function (s) {
                  return s._slotUpdateCompleted;
                });
                _context.next = 5;
                return Promise.all(slotPromises);
              case 5:
                return _context.abrupt("return", true);
              case 6:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
      }
      /*
       * After the component has rendered, this method can be used to retrieve the content assigned to a slot
       */
    }, {
      key: "getAssignedSlotContent",
      value: function getAssignedSlotContent() {
        var slotName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
        var slot;
        if (slotName === 'default') {
          slot = Array.from(this.querySelectorAll(slotTag)).filter(function (n) {
            return n.getAttribute('name') === null;
          }).pop();
        } else {
          slot = this.querySelector("".concat(slotTag, "[name='").concat(slotName, "']"));
        }
        if (!slot) return undefined; // Component hasn't rendered yet, no slot to query
        var slotContent = slot.querySelector(APEX_SLOT_TAGS.ASSIGNED_WRAPPER);
        if (slotContent === null || slotContent === void 0 ? void 0 : slotContent.childNodes) {
          return slotContent.childNodes;
        }
        return undefined;
      }
      /*
       * Before the component has rendered, this method can be used to retrieve child nodes that will be assigned to a slot
       */
    }, {
      key: "getSlotableContent",
      value: function getSlotableContent() {
        var slotName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var sanitizedOptions = Object.assign(Object.assign({}, DEFAULT_SLOT_INTROSPECTION_OPTIONS), options);
        var slotableContent;
        if (slotName === 'default') {
          var isEmptyTextNode = function isEmptyTextNode(n) {
            return n.nodeType === Node.TEXT_NODE && (n.nodeValue == null || n.nodeValue.trim() === '');
          };
          // get all nodes outside apex-root that aren't assigned to another slot
          slotableContent = Array.from(this.childNodes).filter(function (n) {
            // only Element nodes can have tagNames and attributes. if the node is something else, we can
            // safely assume that it should be moved into the default slot.
            if (sanitizedOptions.ignoreComments && n.nodeType === Node.COMMENT_NODE) {
              return false;
            } else if (sanitizedOptions.ignoreWhitespace && isEmptyTextNode(n)) {
              return false;
            }
            return n.nodeType !== Node.ELEMENT_NODE || n.tagName.toLowerCase() !== slotRootTag && n.getAttribute('slot') === null;
          });
        } else {
          slotableContent = Array.from(this.querySelectorAll("[slot='".concat(slotName, "']")));
        }
        return slotableContent;
      }
      /*
       * After the component has rendered, this method can be used to determine if a slot has assigned content
       */
    }, {
      key: "hasAssignedSlotContent",
      value: function hasAssignedSlotContent() {
        var slotName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
        var assignedSlotContent = this.getAssignedSlotContent(slotName);
        if (typeof assignedSlotContent === 'undefined') {
          return false;
        } else {
          return assignedSlotContent.length > 0;
        }
      }
      /*
       * Before the component has rendered, this method can be used to determine if a slot will have content after the component renders
       */
    }, {
      key: "hasSlotableContent",
      value: function hasSlotableContent() {
        var slotName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var sanitizedOptions = Object.assign(Object.assign({}, DEFAULT_SLOT_INTROSPECTION_OPTIONS), {
          options: options
        });
        return this.getSlotableContent(slotName, sanitizedOptions).length > 0;
      }
    }]);
    return ClassInTransition;
  }(superclass);
}

export { ApexSlotableMixin };
